/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react"
import { CircularProgress } from "@material-ui/core"
import { getRequest, putRequest, postRequest } from "utils/request"
import ClientForm from "components/ClientForm"

import "../style.css"

export default function NewCustomer({ match, history }) {
  const [loading, setLoading] = useState(false)
  const [CustomerData, setCustomerData] = useState("")
  // eslint-disable-next-line no-unused-vars
  const [btnGoBack, setBtnGoBack] = useState(true)

  const loadClient = async () => {
    if (match.params.id) {
      setLoading(true)
      //BUSCA DADOS DO CLIENTE
      const ReturnGet = await getRequest(
        `/customers/${match.params.id}?offset=0&limit=1000&text`
      )
      if (ReturnGet.success) {
        setCustomerData(ReturnGet.data)
      }
      setLoading(false)
    }
  }

  useEffect(() => {
    loadClient()
  }, [match])

  const handleConfirm = async (customer) => {
    setLoading(true)

    if (match.params.id) {
      //SALVA ALTERAÇÕES DO CLIENTE
      const ReturnPut = await putRequest(
        `/customers/${match.params.id}`,
        customer
      )
      setLoading(false)
      if (ReturnPut.success) {
        history.push(`../../dashboard/customer`)
      }
    } else {
      //SALVA NOVO CLIENTE
      const ReturnPost = await postRequest(`/customers`, customer)
      setLoading(false)
      if (ReturnPost.success) {
        history.push(`../../dashboard/customer`)
      }
    }
  }

  return (
    <>
      <div className="col-12" style={{ overflowY: "auto" }}>
        <div className="container-card">
          {!loading ? (
            <ClientForm
              match={match}
              CustomerData={CustomerData}
              handleConfirm={handleConfirm}
              btnGoBack={btnGoBack}
              history={history}
            />
          ) : (
            <div className="area-loading">
              <CircularProgress />
            </div>
          )}
        </div>
      </div>
    </>
  )
}
